import { render, staticRenderFns } from "./AdminSupportStaffModal.vue?vue&type=template&id=1ef94eae&scoped=true"
import script from "./AdminSupportStaffModal.vue?vue&type=script&lang=js"
export * from "./AdminSupportStaffModal.vue?vue&type=script&lang=js"
import style0 from "./AdminSupportStaffModal.vue?vue&type=style&index=0&id=1ef94eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef94eae",
  null
  
)

export default component.exports